import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LayoutHeader from './Header'
import AdminNavigation from './AdminNavigation';
import AlumniNavigation from './AlumniNavigation';
import './layout.css';
import { Modal , Button, Row, Col, Input, Form, Icon, message,Card, Upload, notification} from 'antd';
import InputMask from 'react-input-mask'
import SparkOpportunityForm from './SparkOpportunityForm';
import Compress from 'compress.js'
const compress = new Compress()


const FormItem = Form.Item;

const { Dragger } = Upload;


function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  
  const URLtoBase64 = (url, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  };
  
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  
  async function resizeImageFn(file) {
  
    const resizedImage = await compress.compress([file], {
      size: 1, // the max size in MB, defaults to 2MB
      quality: 1, // the quality of the image, max is 1,
      maxWidth: 320, // the max width of the output image, defaults to 1920px
      maxHeight: 320, // the max height of the output image, defaults to 1920px
      resize: true // defaults to true, set false if you do not want to resize the image width and height
    })
    const img = resizedImage[0];
    const base64str = img.data
    const imgExt = img.ext
    const resizedFiile = Compress.convertBase64ToFile(base64str, imgExt)
    console.log(resizedFiile)
    return resizedFiile;
  }
  
  function beforeUpload(file) {
    let CompressedImage = resizeImageFn(file)
    //return CompressedImage
    let isJPG;
    if (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png') {
      isJPG = true
    }else{
      isJPG = false
      message.error('You can only upload Image file (.jpg,.jpeg,.png)!');
    }
    const isLt2M = file.size / 1024 / 1024;
    if (isLt2M > 1) {
      message.error('Image must smaller than 1MB!');
      return false
    }
    return isJPG && isLt2M;
  }


class NeedHelp extends Component {
    constructor(props){
        super(props)
        this.state = {
            isShowNST_modal: false,
            isShowSPARK_OpportunityModal: false,
            isShowProgram_support_modal: false,
            picture: '',
            defaultFileList:'',
            imageUrl:'',
            disable:true,
        }
    }

    componentDidMount = () => {
        this.props.actions.isadmin();
    }
    ShowNST_Modal = () => {
        this.setState({isShowNST_modal: true})
    }
    HideNST_Modal = () => {
        this.setState({isShowNST_modal: false})
    }
    renderNSTPortalModal = () => {
        return <Modal
        className='width-80 directory-help'
        // title="View Membership"
        centered
        // style={{width: '1000px', }}
        visible={this.state.isShowNST_modal}
        onOk={() => this.HideNST_Modal()}
        onCancel={() => this.HideNST_Modal()}
        footer={null}
    >
        <div >
        <iframe style={{width: '100%', height: '600px'}} src='https://d153zqp2yevlxw.cloudfront.net/NST%20ALUMNI%20PORTAL%20SPECIALIST%20(As%20of%20March%2014%202023).pdf' title='NST ALUMNI PORTAL SPECIALISTS' />
        </div>
        
    </Modal>
    }

    ShowProgram_support_Modal = () => {
      this.setState({isShowProgram_support_modal: true})
  }
  HideProgram_support_Modal = () => {
      this.setState({isShowProgram_support_modal: false})
  }
  renderProgram_supportModal = () => {
      return <Modal
      className='width-80 directory-help'
      // title="View Membership"
      centered
      // style={{width: '1000px', }}
      visible={this.state.isShowProgram_support_modal}
      onOk={() => this.HideProgram_support_Modal()}
      onCancel={() => this.HideProgram_support_Modal()}
      footer={null}
  >
      <div >
      <iframe style={{width: '100%', height: '600px'}} src='https://d153zqp2yevlxw.cloudfront.net/Program%20Support%20team%20rel.%20031722.pdf' title='NST ALUMNI PORTAL SPECIALISTS' />
      </div>
      
  </Modal>
  }


    ShowSPARK_OpportunityModal = () => {
        this.setState({
            isShowSPARK_OpportunityModal: true
        })
    }

    hideSPARK_OpportunityModal = () => {
        this.setState({
            isShowSPARK_OpportunityModal: false
        })
    }

    toDataURL = (url, callback) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
            callback(reader.result);
          }
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      }

      // this function commented to test the API 
    // convertToDoc = (element, filename, imgUrl) => { 
    //     var image = document.createElement('img');
    //     image.setAttribute('id', 'Spark-Attachments');

    //     var body = document.getElementById(element);
    //     body.appendChild(image)
    //     document.getElementById('Spark-Attachments').src = imgUrl

    //     var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body> ";


    //     var postHtml = "</body></html>";
    //     var html = preHtml + document.getElementById(element).innerHTML + postHtml;

    //     var blob = new Blob(['\ufeff', html], {
    //         type: 'application/msword'
    //     });

        
    //     // Specify link url
    //     var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

    //     this.toDataURL(url, data => {
    //         console.log("URL******" + data)
    //     }
    //       );
          
    //     // Specify file name
    //     filename = filename ? filename + '.doc' : 'document.doc';

    //     // Create download link element
    //     var downloadLink = document.createElement("a");

    //     document.body.appendChild(downloadLink);

    //     if (navigator.msSaveOrOpenBlob) {
    //         navigator.msSaveOrOpenBlob(blob, filename);
    //     } else {
    //         // Create a link to the file
    //         downloadLink.href = url;

    //         // getBase642(downloadLink, imageUrl => { 
    //         // console.log(imageUrl)
    //         // })
    //         // Setting the file name
    //         downloadLink.download = filename;

    //         //triggering the function
    //         downloadLink.click();
    //     }

    //     document.body.removeChild(downloadLink);

    // }
  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
        console.log('****Info ' + JSON.stringify(info));
      let loggedinUser = JSON.parse(localStorage.getItem('user'))
      let personGUID = loggedinUser.personGuid;
      getBase64(info.file.originFileObj, imageUrl => {

        let code = imageUrl;
        code = code.split(','),
        code = code[1];
        console.log("code " + code);
        
        // this.props.actions.updateProfilePicture(personGUID, imageUrl, picturemethod, 'Updated')
        this.setState({
            defaultFileList: info.fileList,
          imageUrl: code,
          loading: false,
        })
      }
      );
    }
  }

  // handleSubmit = e => {
  //   e.preventDefault();
  //   this.props.form.validateFieldsAndScroll((err, values) => {
        
  //       if (!err) {
  //           // this.Export2Word('Spark-Opportunity-form-div', 'Spark', this.state.imageUrl)
  //           // this.convertToDoc('Spark-Opportunity-form-div', 'Spark', this.state.imageUrl) // this function commented to test the API 

  //           this.props.actions.sentSparkOpportunityFormToMail(values, this.state.imageUrl ? this.state.imageUrl : '')
  //       }
  //   })
  // }
  
    renderSPARK_OpportunityModal = () => {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;

        // return <Modal
        //     // title="Spark Opportunity Form"
        //     centered
        //     // closable={false}
        //     onOk={() => this.hideSPARK_OpportunityModal()}
        //     onCancel={() => this.hideSPARK_OpportunityModal()}
        //     className="add-membership-modal"
        //     visible={this.state.isShowSPARK_OpportunityModal}
        //     footer={false}
        // >
        //     {/* <Row type="flex" justify="center" align="center"> */}
        //         <div style={{display: 'flex', justifyContent:'center'}}>
        //             <img src='../Spark Opportunity.png' style={{ width: '30%' }} />
        //         </div>
        //     {/* </Row> */}
        //     <Form layout="vertical" onSubmit={this.handleSubmit}>
        //         <Row gutter={48} type="flex" justify="center" align="center">
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Name"
        //                     hasFeedback
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('name', {
        //                         rules: [{ required: true, message: 'Enter Name!' }],
        //                     })(
        //                         <Input placeholder="Name" />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Date"
        //                     hasFeedback
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('date', {
        //                         initialValue: '',
        //                         rules: [
        //                             { required: true, message: 'Enter the date!' },
        //                             {
        //                                 pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
        //                                 message: `Please enter correct format MM/DD/YYYY Pattern`
        //                             }
        //                         ],
        //                     })(
        //                         // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
        //                         <InputMask
        //                             mask="99/99/9999"
        //                             placeholder='MM/DD/YYYY'
        //                             style={{ borderRadius: 5 }}
        //                             alwaysShowMask
        //                             maskChar={null}
        //                             className="ant-input"
        //                             render={(ref, props) => (
        //                                 <Input />
        //                             )}
        //                         />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Computer Type (PC, phone, tablet)"
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('computerType', {
        //                         rules: [{ required: true, message: 'Enter Your Computer Type!' }],
        //                     })(
        //                         <Input placeholder="(PC, phone, tablet)" />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Browser"
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('browser', {
        //                         rules: [{ required: true, message: 'Enter Browser!' }],
        //                     })(
        //                         <Input />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Area of Concern"
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('areaOfConcern', {
        //                         rules: [{ required: true, message: 'Select Your Area of Concern!' }],
        //                     })(
        //                         <Input />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             {/* <Col span={12}>
        //                         <FormItem
        //                             label="Payment Mode"
        //                         >
        //                             {getFieldDecorator('payment_mode', {
        //                                 rules: [{ required: true, message: 'Enter Membership Payment Mode!' }],
        //                             })(
        //                                 <Input placeholder="Payment Mode" />
        //                             )}
        //                         </FormItem>
        //                     </Col> */}
        //             <Col span={12}>
        //                 <FormItem
        //                     label="Type of issue"
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('typeOfIssue', {
        //                         rules: [{ required: true, message: 'Select Your Issue Type!' }],
        //                     })(
        //                         <Input />
        //                     )}
        //                 </FormItem>
        //             </Col>

        //             <Col span={24}>
        //                 <FormItem
        //                     label="If you choose “Other” please elaborate below"
        //                     style={{padding: '0px'}}
        //                 >
        //                     {getFieldDecorator('briefDescription', {
        //                         rules: [{ required: false, message: 'Enter Brief Description of the issue!' }],
        //                     })(
        //                         <TextArea rows={4} />
        //                     )}
        //                 </FormItem>
        //             </Col>
        //             {/* <Col span={12}> */}
        //                 {/* <Form.Item
        //                     className="input"
                            
        //                     name="checkPic"
        //                     label="NOTE:  Please provide a screen shot if necessary to explain the issue."
        //                     rules={[
        //                         {

        //                             message: "Upload Screenshot",
        //                         },
        //                     ]
        //                 }
        //                 style={{padding: '0px'}}
        //                 >
        //                     <Dragger
        //                         // accept=".jpg,.jpeg,.png"
        //                         className="profile-pic-uploader"
        //                         name="file"
        //                         listType="file"
        //                         // defaultFileList={this.state.defaultFileList}
        //                         // showUploadList={false}
        //                         customRequest={dummyRequest}
        //                         beforeUpload={beforeUpload}
        //                         onChange={this.handleChange}
        //                     >
        //                         {/* NOTE:  Please provide a screen shot if necessary to explain the issue. */}
        //                         {/* <p className="ant-upload-drag-icon">
        //                             <Icon type="inbox" />
        //                         </p>
        //                         <p className="ant-upload-text">Click or drag file to this area to upload</p>

        //                     </Dragger>
        //                 </Form.Item>
        //             </Col> */} 
        //         </Row>
        //         <Row type="flex" justify="space-between">
        //             <Col xs={24} sm={24} md={10} lg={10}>
        //                 <FormItem>
        //                     <Button className="form-cancel-btn modal-btn" onClick={() => this.hideSPARK_OpportunityModal()}> Cancel </Button>
        //                 </FormItem>
        //             </Col>
        //             <Col xs={24} sm={24} md={10} lg={10}>
        //                 <FormItem>
        //                     <Button loading={this.props.loading ? true : false} className="form-submit-btn modal-btn" htmlType="submit"> Submit </Button>
        //                 </FormItem>
        //             </Col>
        //         </Row>
        //     </Form>
        // </Modal>

    }

    componentWillReceiveProps = (nextprops) => {
        // if (this.props.isSendingMail !== nextprops.isSendingMail) {
        //     nextprops.isSendingMail ? notification['error']({
        //         message: 'Error',
        //         description:
        //             `Couldn't send mail, Please try again`,
        //     }) : ''
        // }
        if (this.props.mailSent !== nextprops.mailSent) {
            if(nextprops.mailSent){
             notification['success']({
                message: 'Success',
                description:
                    `Mail sent successfully`,
            })
            this.hideSPARK_OpportunityModal()
         }
        }
        if (this.props.mailFailed !== nextprops.mailFailed) {
            if(nextprops.mailFailed){
            notification['error']({
                message: 'Error',
                description:
                    `Couldn't send mail, Please try again`,
            })
            }  
            
        }
    }
    render () {
        return (
            <div>
            <LayoutHeader />

            {(this.props.isadmin == true || this.props.isspecialist === true ) &&
                <AdminNavigation />
            }

            {(this.props.isadmin == false || this.props.isspecialist === false ) &&
                <AlumniNavigation />
            }

            <div className='NeedHelp-container'>
                <div className='Alumni-Directory-Resource-Header'> Alumni Directory Resources </div>

                <div className='NST-Alumni-help help-section'>
                    <div className='NST-Alumni-help-header help-header'>NST Alumni Portal Specialists Contact Information </div>
                    <div className='NST-Alumni-help-body help-body'>
                        The <Button onClick={() => this.ShowNST_Modal()} type="link" style={{padding: '0px'}} >NST Alumni Portal Specialists</Button> represent a group of advance use volunteers who review the current Alumni Directory, 
                        capturing and documenting bugs, identifying UI type of irregularities and are a sounding board to help identify enhancements
                        and improvements to the Directory portal.
                    </div>
                </div>

                {this.renderNSTPortalModal()}

                <div className='Program-support-help help-section'>
                    <div className='Program-support-help-header help-header'> Program Support: </div>
                    <div className='program-support-help-body help-body'>
                        The <Button onClick={() => this.ShowProgram_support_Modal()} type="link" style={{padding: '0px'}} >Program Support team </Button> consists of two components: the National Service Center team 
                        and a team of volunteers with unique talents and skill committed to delivering and enhancing 
                        the Alumni Directory portal.Contact information is available via the above link.
                    </div>
                </div>
                {this.renderProgram_supportModal()}
                
                <div className='Spark-opportunity-help help-section'>
                    <div className='Spark-opportunity-help-header help-header'>Spark Opportunity Form:</div>
                    <div className='Spark-opportunity-help-body help-body'>
                        The <Button onClick={() => this.ShowSPARK_OpportunityModal()} type="link" style={{padding: '0px'}} className='spark-opportunity-cls' id='spark-opportunity-id' >Spark Opportunity Form</Button> is a survey like service designed as the input site for Alumni Specialists to capture and 
                        record any issues or enhancements that will improve the Directory portal’s user experience.
                    </div>
                </div>
                {/* {this.renderSPARK_OpportunityModal()} */}

                <SparkOpportunityForm 
                hideSPARK_OpportunityModalHandler = {this.hideSPARK_OpportunityModal}
                // handleSubmitHandler = {this.handleSubmit}
                isShowSPARK_OpportunityModal = {this.state.isShowSPARK_OpportunityModal}
                />
            <div id='Spark-Opportunity-form-div' style={{display: 'none'}}></div>
        
                {/* <div className='Release-notes-help help-section'>
                    <div className='Release-notes-help-header help-header'>Release Notes</div>
                    <div className='Release-notes-help-body help-body'>
                        <a href='' className=''>Release Notes</a> provide advance users (Specialists role) with an over-view of the continuing list of bug 
                        fixes, feature enhancements or new functionality added to the Directory portal.  
                        The displayed information reflects the delivered functionality with more detailed information available via the above link.  
                        Only current updates are presented; subsequent release information is available via the above link.
                    </div>
                </div> */}

            </div>

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isadmin: state.isadminreducer.isadmin,
        isspecialist: state.isadminreducer.isspecialist,
        isSendingMail: state.sparkOpportunityFormReducer.isSendingMail,
        mailSent: state.sparkOpportunityFormReducer.mailSent,
        mailFailed: state.sparkOpportunityFormReducer.mailFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(NeedHelp));


// WEBPACK FOOTER //
// ./src/components/Inc/NeedHelp.js